import { ColumnMapping, ExcelProcessorConfig, HeaderConfig, ParsedExcelData, ValidationError } from '@/lib/excel';

export interface ImportBody {
  client_key: string;
  ma_thu_chi: string;

  ten_thu_chi: string;
  ma_cha: string | null;
  trang_thai: number;
  ghi_chu: string | null;
  stt: number;
}

const HEADERS = {
  ma_thu_chi: 'Mã thu chi*',
  ten_thu_chi: 'Tên thu chi*',
  ma_cha: 'Mã cha',
  ghi_chu: 'Ghi chú',
  stt: 'Số thứ tự'
};

const HEADER_CONFIG: HeaderConfig[] = [
  { header: HEADERS.ma_thu_chi, key: 'ma_thu_chi', type: 'main' },
  { header: HEADERS.ten_thu_chi, key: 'ten_thu_chi', type: 'main' },
  { header: HEADERS.ma_cha, key: 'ma_cha', type: 'main' },
  { header: HEADERS.ghi_chu, key: 'ghi_chu', type: 'main' },
  { header: HEADERS.stt, key: 'stt', type: 'main' }
];

const getFieldName = (key: string) => {
  const config = HEADER_CONFIG.find(c => c.key === key);
  return config?.header?.replace('*', '').trim() || key;
};

const TransformToBodies = (
  dataRows: unknown[][],
  parsedData: ParsedExcelData,
  uuidResponse: unknown,
  context: unknown
): ImportBody[] => {
  console.log('TransformToBodies parsedData:', parsedData);
  if (!parsedData) {
    console.error('parsedData is undefined');
    return [];
  }
  const { main = {} } = parsedData;
  const bodies: ImportBody[] = [];

  for (let i = 0; i < dataRows.length; i++) {
    const ma_thu_chi = main.ma_thu_chi?.[i]?.toString() || '';
    const ten_thu_chi = main.ten_thu_chi?.[i]?.toString() || '';

    // Skip if required fields are missing
    if (!ma_thu_chi || !ten_thu_chi) continue;

    const ma_cha = main.ma_cha?.[i]?.toString() || null;
    const client_key = `row-${i + 1}`;

    bodies.push({
      client_key,
      ma_thu_chi,

      ten_thu_chi,
      ma_cha,
      trang_thai: 1,
      ghi_chu: main.ghi_chu?.[i]?.toString() || '',
      stt: main.stt?.[i] ? parseInt(main.stt[i], 10) : 0
    });
  }

  return bodies;
};

export const ExcelConfig: ExcelProcessorConfig<ImportBody> = {
  Headers: HEADERS,
  HeaderConfig: HEADER_CONFIG,
  RequiredFields: [
    { key: 'ma_thu_chi', type: 'main', label: 'Mã thu chi' },
    { key: 'ten_thu_chi', type: 'main', label: 'Tên thu chi' }
  ],
  Transform: TransformToBodies
};
